const disease = {
  path: '/disease',
  name: 'disease',
  component: resolve => require(['@/views/disease/disease.vue'], resolve),
  children:[
    {
      path: 'eyehome',  //眼睛一点通
      meta:{
        // tabBar: false,
        timeBar: true,
//        useKeepAlive:'false'
      },
      component: resolve => require(['@/views/disease/eyehome.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'fathome',//肥胖一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/fathome.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'bloodhome',//血压一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/bloodhome.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'cublove',//早恋一点通
      meta:{
        // tabBar: false,
        timeBar: true,
      },
      component: resolve => require(['@/views/disease/cublove.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'tumour',// 肿瘤一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/tumour.vue'], resolve),
      children:[

      ]
    },{
      path: 'tumour_new',// 新肿瘤一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/tumour_new.vue'], resolve),
      children:[

      ]
    },

    {
      path: 'stomach',// 肠胃一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/stomach.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'depressed',// 抑郁一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/depressed.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'cosmetology',// 美容一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/cosmetology.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'mother_daughter',// 婆媳一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/mother_daughter.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'generation_gap',// 代沟一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/generation_gap.vue'], resolve),
    },
    {
      path: 'damp',// 祛湿一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/damp.vue'], resolve),
    },
    {
      path: 'diet',//饮食一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/diet.vue'], resolve),
    },
    {
      path: 'dementia',//痴呆一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/dementia.vue'], resolve),
    },
    {
      path: 'glucose',//血糖一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/glucose.vue'], resolve),
    },
    {
      path: 'heart',//心智养生
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/heart.vue'], resolve),
    },
    {
      path: 'sleep',//睡眠养生
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/sleep.vue'], resolve),
    },
    {
      path: 'environment',//环境养生
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/environment.vue'], resolve),
    },
    {
      path: 'movement',//运动养生
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/movement.vue'], resolve),
    },
    {
      path: 'pregnant_anemia',//孕妇贫血
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/pregnant_anemia.vue'], resolve),
    },
    {
      path: 'liabilities',//负债一点通
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/liabilities.vue'], resolve),
    },
    {
      path: 'vegetarian',//服务通吃素的意义
      meta:{
        // tabBar: false
      },
      component: resolve => require(['@/views/disease/vegetarian.vue'], resolve),
    },
    {
      path: 'diseaseKown',//点通系列公用的详情页
      meta:{
        // tabBar: false,
        timeBar: true
      },
      component: resolve => require(['@/views/disease/diseaseKown.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'demo',
      meta:{
        tabBar: false,
      },
      component: resolve => require(['@/views/disease/demo.vue'], resolve),
      children:[

      ]
    },
    {
      path: 'product_message',//公用的产品资讯
      meta:{
        // tabBar: false,
      },
      component: resolve => require(['@/views/disease/product_message.vue'], resolve),
    },
  ]
};

export default disease;
